'use strict';

angular.module('ClinicApp').controller('ModalClinicCallNotificationFeature', function($scope, $modalInstance, ClinicResource, clinic) {
  $scope.featureEnabled = false;
  $scope.isSubmitting = false;

  $scope.close = function() {
    $modalInstance.dismiss('cancel');
  };

  $scope.toggleCallNotification = function() {
    $scope.isSubmitting = true;
    ClinicResource.update({
      id: clinic.id,
    }, {
      address: clinic.address,
      latitude: clinic.latitude,
      longitude: clinic.longitude,
      notificationSettings: {
        ...clinic.notificationSettings,
        unviewedAppointmentsReminder: true,
      },
    }).$promise.then(function() {
      $scope.isSubmitting = false;
      $scope.featureEnabled = true;
    });
  };
});
